import { render, staticRenderFns } from "./DocumentTypeForm.vue?vue&type=template&id=2143c15a&"
import script from "./DocumentTypeForm.vue?vue&type=script&lang=js&"
export * from "./DocumentTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./DocumentTypeForm.vue?vue&type=style&index=0&id=2143c15a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports